import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export type MigratedMacroExtensionKey =
	| 'attachments'
	| 'blog-posts'
	| 'change-history'
	| 'content-report-table'
	| 'contributors'
	| 'detailssummary'
	| 'iframe'
	| 'include'
	| 'pagetree'
	| 'pagetreesearch'
	| 'profile'
	| 'profile-picture'
	| 'recently-updated'
	| 'viewpdf'
	| 'widget'
	| 'contentbylabel'
	| 'popular-labels'
	| 'tasks-report-macro';

const getExperimentValue = (extensionKey: MigratedMacroExtensionKey): boolean => {
	switch (extensionKey) {
		case 'blog-posts':
			return expValEquals('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
		case 'content-report-table':
			return expValEquals('cc_rewrite_content-report-table', 'isEnabled', true);
		case 'contentbylabel':
			return expValEquals('cc_rewrite_contentbylabel_legacy_macro', 'isEnabled', true);
		case 'contributors':
			return expValEquals('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
		case 'detailssummary':
		case 'profile':
		case 'profile-picture':
			return expValEquals('cc_macro_full_ssr_support', 'isEnabled', true);
		case 'iframe':
			return expValEquals('cc_rewrite_iframe_legacy_macro', 'isEnabled', true);
		case 'pagetree':
			return expValEquals('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
		case 'pagetreesearch':
			return expValEquals('cc_rewrite_pagetree_search_legacy_macro', 'isEnabled', true);
		case 'popular-labels':
			return expValEquals('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
		case 'recently-updated':
			return expValEquals('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
		case 'viewpdf':
			return expValEquals('cc_rewrite_viewpdf_macro', 'isEnabled', true);
		case 'widget':
			return expValEquals('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
		case 'attachments':
		case 'include':
		case 'tasks-report-macro':
		case 'change-history':
			return expValEquals('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
		default:
			return false;
	}
};

const isMigratedMacroExtensionKey = (key: string): key is MigratedMacroExtensionKey =>
	[
		'attachments',
		'blog-posts',
		'change-history',
		'content-report-table',
		'contributors',
		'detailssummary',
		'iframe',
		'include',
		'pagetree',
		'pagetreesearch',
		'recently-updated',
		'widget',
		'contentbylabel',
		'popular-labels',
		'profile',
		'profile-picture',
		'viewpdf',
		'tasks-report-macro',
	].includes(key);

export const isMigratedMacroImplEnabled = (extensionKey: string): boolean => {
	const overrideList = StatsigConfigurations.getStringList(
		'cc_macro_override_to_legacy_renderer',
		[],
	);

	if (overrideList.includes(extensionKey)) {
		return false;
	}

	if (!isMigratedMacroExtensionKey(extensionKey)) {
		return false;
	}

	return getExperimentValue(extensionKey);
};
